import React, { Component, Fragment } from "react";
import "moment/locale/fr";

import List from "../../../components/list/List";
import Pagination from "components/pagination/Pagination";
import typologiesListColumn from "./TypologiesList.utils";

class TypologiesList extends Component {
  componentDidMount() {
    this.props.init("typologies");
  }

  render() {
    const { typologiesList, page, pages, pageSize, nbItems, getNext } = this.props;

    return (
      <div class="p-content-page-center p-content-page-center-full">
        <div class="p-content-page-center-header">
          <h2 class="p-content-page-center-header-title">Liste des typologies</h2>
        </div>
        <div class="p-content-page-center-content">
          <List columns={typologiesListColumn} data={typologiesList} defaultText="Aucune typologie trouvée." />
          <div className="p-al-right p-mrg-ver">
            <Pagination page={page} pages={pages} pageSize={pageSize} nbItems={nbItems} getNext={getNext} />
          </div>
        </div>
      </div>
    );
  }
}

export default TypologiesList;



// WEBPACK FOOTER //
// src/containers/admin/typologies/TypologiesList.js